import React, { Component } from "react";
import PropTypes from "prop-types";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
// import paginationFactory from 'react-bootstrap-table2-paginator'
import overlayFactory from "react-bootstrap-table2-overlay";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Col,
} from "reactstrap";
import MediaQuery from "react-responsive";
import { layout } from "../../../common/constants";

const pageLimits = {
  sm: 5,
  md: 7,
  lg: 10,
};

class DataTable extends Component {
  onPageChange(page) {
    this.props.onPageChange(page);
  }

  renderNoDataIndication() {
    if (this.props.loading) {
      return <div style={{ height: 40 }}></div>;
    } else {
      return <div>No existe contenido para mostrar</div>;
    }
  }

  renderPages(pages, pageLimit = 10) {
    var pageItems = [];
    var pageStart = 1;
    var pageEnd = pages;
    var pagePos = this.props.page;

    if (pageLimit < 1) pageLimit = 5;

    if (pageLimit < pageEnd) {
      if (pagePos == pageStart) pageStart = pagePos;
      else if (pagePos == pageEnd) pageStart = pagePos - pageLimit + 1;
      else {
        pageStart = pagePos - (pageLimit - (pageLimit % 2)) / 2;
        if (pageStart < 1) pageStart = 1;
      }

      var pageEnd = pageStart + pageLimit - 1;
      if (pageEnd > pages) {
        var dif = pageEnd - pages;
        pageEnd = pages;
        pageStart -= dif;
      }
    }

    for (let i = pageStart; i <= pageEnd; i++) {
      pageItems.push(
        <PaginationItem
          key={i}
          active={this.props.page == i}
          disabled={this.props.loading}
          onClick={() => this.onPageChange(i)}
        >
          <PaginationLink>{i}</PaginationLink>
        </PaginationItem>
      );
    }

    return pageItems;
  }

  renderPagination(pagelimit) {
    const { page, totalSize, sizePerPage, loading } = this.props;

    if (!totalSize || !page) return <div></div>;

    const pages = Math.ceil(totalSize / sizePerPage);
    const renderPrevButton = page != 1;
    const renderNextButton = page < pages;
    const renderFirstButton = page - 2 >= 1;
    const renderLastButton = page + 2 <= pages;

    return (
      <Pagination>
        {renderFirstButton && (
          <PaginationItem
            disabled={loading}
            onClick={() => this.onPageChange(1)}
          >
            <PaginationLink>{"<<"}</PaginationLink>
          </PaginationItem>
        )}
        {renderPrevButton && (
          <PaginationItem
            disabled={loading}
            onClick={() => this.onPageChange(page - 1)}
          >
            <PaginationLink>{"<"}</PaginationLink>
          </PaginationItem>
        )}
        {this.renderPages(pages, pagelimit)}
        {renderNextButton && (
          <PaginationItem
            disabled={loading}
            onClick={() => this.onPageChange(page + 1)}
          >
            <PaginationLink>{">"}</PaginationLink>
          </PaginationItem>
        )}
        {renderLastButton && (
          <PaginationItem
            disabled={loading}
            onClick={() => this.onPageChange(pages)}
          >
            <PaginationLink>{">>"}</PaginationLink>
          </PaginationItem>
        )}
      </Pagination>
    );
  }

  render() {
    return (
      <div>
        <BootstrapTable
          remote
          striped
          hover
          keyField={this.props.keyField}
          data={this.props.data}
          columns={this.props.columns}
          onTableChange={this.props.onTableChange}
          noDataIndication={() => this.renderNoDataIndication()}
          loading={this.props.loading}
          overlay={overlayFactory({
            spinner: true,
            background: "rgba(192,192,192,0.3)",
          })}
        />

        <Row className="float-right">
          <Col>
            <MediaQuery maxWidth={layout.SM_MAX_WIDTH}>
              {this.renderPagination(pageLimits.sm)}
            </MediaQuery>
            <MediaQuery
              minWidth={layout.MD_MIN_WIDTH}
              maxWidth={layout.LG_MAX_WIDTH}
            >
              {this.renderPagination(pageLimits.md)}
            </MediaQuery>
            <MediaQuery minWidth={layout.XL_MIN_WIDTH}>
              {this.renderPagination(pageLimits.lg)}
            </MediaQuery>
          </Col>
        </Row>
      </div>
    );
  }
}

DataTable.propTypes = {
  data: PropTypes.array,
  page: PropTypes.number,
  sizePerPage: PropTypes.number,
  totalSize: PropTypes.number,
  columns: PropTypes.array,
  loading: PropTypes.bool,
  keyField: PropTypes.string,
  onTableChange: PropTypes.func,
  onPageChange: PropTypes.func,
};

DataTable.defaultProps = {
  sizePerPage: 10,
  loading: false,
};

export default DataTable;



// WEBPACK FOOTER //
// ./src/components/Table/DataTable/DataTable.js